export const backofficeModuleCodes = {
	processingWeek: 15760,
	accountability: 15770,
	actionPage: 15783,
	processingWeekIncreaseWarning: 15784,
	lastProcessed: 15785,
	backofficeProcess: 15782,
	processTimecards: 15788,
	process: 15789,
	processForInvoices: 15790,
	processForWageAndInvoices: 15791,
	increaseProcessingWeek: 15792,
	increaseProcessingWeekConfirmationMessage: 15793,
	processing: 15781,
	processor: 15812,
	wageDetails: 15814,
	publish: 15815,
	publishing: 15816,
	processedForInvoices: 15818,
	wage: {
		processWageDetails: 15817,
		wageTotalSum: 15823,
		number: 15824,
		bureau: 15825,
		workedWeek: 15826,
		amount: 15827,
		totalWageDetails: 15829,
		timecard: 15858,
	},
	currentProcessingWeek: 15831,
	publishPayslips: 15832,
	payslipsExportAndPublishMessage: 15833,
	payslipPeriodType: 15834,
	createdStatusOnly: 15836,
	paymentLinesTotalSumExplanation: 15843,
	processPaymentLines: 15851,
	processPaymentOrders: 15856,
	beneficiaryName: 15857,
	paymentOrdersSetDesiredProcessingDate: 15867,
	processingDate: 15868,
	fileName: 15880,
	processingId: 15881,
	paymentTransferFiles: 15895,
	journalTransferFiles: 15780,
	transferFiles: {
		ledgerAdministration: 15882,
		fileName: 15880,
		transferType: 15883,
		debitAmount: 15884,
		creditAmount: 15885,
		creationDateFrom: 15909,
		creationDateTo: 15910,
	},
	journalTransferFile: 15911,
	debtorOrCreditorFile: 15912,
	goToAccountabilityFiles: 15913,
	createJournalTransferFile: 15914,
	createJournalTransferFileConfirmationMessage: 15915,
	createDebtorOrCreditorFile: 15916,
	debtor: 15917,
	creditor: 15918,
	createPaymentTransferFileConfirmationMessage: 15919,
	createPaymentTransferFileDownloadMessage: 15920,
	goToPaymentTransferFiles: 15921,
	creating: 15923,
	workedPeriod: 15925,
	source: 16485,
};
